import DeleteModal from '@/components/Modals/DeleteModal';
import { useDeleteCampaign } from '@/pages/campaign/ListPage/api';
import { useAnalytics } from '@/services/analytics';
import { ICampaign } from '@d-id/types';
interface Props {
    itemToDelete: ICampaign | null;
    onClose: () => void;
}

export const DeleteCampaignModal = ({ itemToDelete, onClose }: Props) => {
    const mixpanel = useAnalytics();
    const { mutateAsync: deleteItem, isLoading: isDeleting } = useDeleteCampaign();

    const onItemDelete = async () => {
        if (!itemToDelete) {
            return;
        }

        mixpanel?.track('campaigns-delete', {
            event: 'confirm',
            campaign: itemToDelete,
        });

        await deleteItem(itemToDelete.id);
    };

    return (
        <DeleteModal
            itemType="campaign"
            mode="square"
            open={!!itemToDelete}
            isLoading={isDeleting}
            onDelete={onItemDelete}
            onClose={onClose}
            poster={itemToDelete?.presenter.thumbnail ?? itemToDelete?.presenter?.thumbnail ?? ''}
            text={{
                title: 'Confirm delete',
                content: 'Are you sure you want to delete this campaign from your gallery?',
                cta: 'Delete campaign',
            }}
        />
    );
};
